import { render } from "./TheEventListItem.vue?vue&type=template&id=1543d478&scoped=true&ts=true&lang=html"
import script from "./TheEventListItem.vue?vue&type=script&lang=ts"
export * from "./TheEventListItem.vue?vue&type=script&lang=ts"

import "./TheEventListItem.vue?vue&type=style&index=0&id=1543d478&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1543d478"]])

export default __exports__